export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvar"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se você está vendo isso, o formulário não foi recebido (mas você não deveria estar vendo isso)"])}
}